import { Trans } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

const IdeaPublicStatusChanged = ({
  events = [],
  ownerIdea,
  notificationType,
}: NotificationContentProps & { notificationType?: string }) => {
  const lastEvent = events[events.length - 1];
  const newStatusName = lastEvent?.newStatus?.name || "Unknown";
  const statusChanged =
    !lastEvent?.previousStatus?._id ||
    lastEvent.previousStatus._id !== lastEvent.newStatus?._id;

  const i18nKey =
    notificationType === "ideaAuthorUpdate"
      ? statusChanged
        ? "notifications.ideaAuthorUpdate"
        : "notifications.ideaAuthorUpdateSameStatus"
      : "notifications.ideaPublicStatusChanged";

  return (
    <Trans
      i18nKey={i18nKey}
      values={{
        name: util.getEventNames(events ?? []),
        idea: ownerIdea?.name || "Deleted",
        status: newStatusName,
      }}
    />
  );
};

export default IdeaPublicStatusChanged;
